{"id":"Cart.PaymentMethodsBox","prefabs":{"default":{"children":[{"component":"Cart.PaymentMethodsBox","options":"options:*"}]}}}